import { Transaction, TransactionsByMonth } from "../../types/Transaction";
import { get, post } from "./authenticatedrequestUtil";
import { ClassifiedTransactions } from "../../types/ClassifiedTransactions";

export const getTransactions = get<Transaction[]>(
  ({ companyId }) => `/${companyId}/transactions`
);

export const getTransactionsMonth = get<TransactionsByMonth[]>(
  ({ companyId }) => `/${companyId}/transactions/month`
);

export const editTransaction = post<{}>(
  ({ companyId }) => `/${companyId}/transactions`
);

export const reconcileTransactions = post<{}>(() => `/transactions/reconcile`);

export const transactionReport = post<{}>(() => `/transactions/report`);

export const incomeStatement = get<{ message: string; url: string }>(
  () => `/transactions/reconcile`
);

export const classifyTransactions = get<ClassifiedTransactions>(
  ({ companyId }) => `/${companyId}/transactions/classify`
);
